module.exports = __webpack_public_path__ + "/content/skins/acura/fonts/AcuraBespoke/acura_bespoke-regular-webfont.eot";